import React, { useEffect } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import HeroSection from "../../../layout/HeroSection";
import Loader from "../../../components/other/Loader";
import { pageRoutes } from "../../../routes/pageRoutes";

const EventDetail = () => {
  //   if (isLoading) {
  //     return <Loader />;
  //   }

  return (
    <div>
      <Header />

      <HeroSection
        label={<h1 class="mb-3">{"Event Details"}</h1>}
        breadcrumbItems={[
          { name: "Home", path: `${pageRoutes?.home}` },
          {
            name: "Events",
            path: pageRoutes?.more?.eventCoverageResults,
          },
          {
            name: "Event Details",
            path: `${pageRoutes?.home}/`,
          },
        ]}
      />
      <div class="untree_co-section product-section py-5">
        {/* <!-- <h2 class="section-title mb-5 text-center pb-5"><strong>Top Products</strong></h2> --> */}

        <div class="container">
          <div class="row">
            <div class="col-md-10 mx-auto" data-aos-duration="1000">
              <div
                class="ct_service_card pt-4"
                style={{ backgroundColor: "#f5f5f5" }}
              >
                <figure>
                  <div class="ct_service_img">
                    <img src="images/image_345.jpg" alt="Robotic_img" />
                  </div>

                  {/* <Description text={descriptionText} maxLength={50} /> */}
                  <figcaption>
                    <h4>This page is on working</h4>
                    <span className="ct_fs_16 ct_fw_600">Date:22-02-2022</span>
                    <p className="ct_d_block_c ct_reset_text_overflow mt-3">
                      {/* <div
                        dangerouslySetInnerHTML={
                          {
                            //   __html: serviceDetail?.service_description,
                          }
                        }
                      /> */}
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen book. It has survived not only five
                      centuries, but also the leap into electronic typesetting,
                      remaining essentially unchanged. It was popularised in the
                      1960s with the release of Letraset sheets containing Lorem
                      Ipsum passages, and more recently with desktop publishing
                      software like Aldus PageMaker including versions of Lorem
                      Ipsum Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen book. It has survived not only five
                      centuries, but also the leap into electronic typesetting,
                      remaining essentially unchanged. It was popularised in the
                      1960s with the release of Letraset sheets containing Lorem
                      Ipsum passages, and more recently with desktop publishing
                      software like Aldus PageMaker including versions of Lorem
                      Ipsum
                    </p>
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default EventDetail;
